export default {
      id: "common__signal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__signal",
      toString: function () {
        return this.url;
      }
    }